import React from 'react';
import styles from './JobCard.module.css';
import LinkRecruitmentDetail from '@components/common/Link/LinkRecruitmentDetail';
import {getLocaleContent} from '@helper/locale-content.js';
import {useRouter} from 'next/router';

/**
 * Component thẻ hiển thị thông tin vị trí tuyển dụng
 * @param {Object} job - Thông tin vị trí tuyển dụng
 */
export default function JobCard({job}) {
    const {locale} = useRouter();
    // Định dạng ngày tháng theo chuẩn Việt Nam
    const formatDate = dateString => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('vi-VN');
    };

    // Chuyển đổi mã loại hình làm việc sang tên hiển thị
    const getEmploymentTypeName = (type, locale = 'vi') => {
        const types = {
            vi: {
                1: 'Toàn thời gian',
                2: 'Bán thời gian',
                3: 'Thực tập',
                4: 'Hợp đồng',
            },
            en: {
                1: 'Full-time',
                2: 'Part-time',
                3: 'Internship',
                4: 'Contract',
            },
        };

        const selectedTypes = types[locale] || types['vi'];
        return selectedTypes[type] || (locale === 'en' ? 'Full-time' : 'Toàn thời gian');
    };

    return (
        <LinkRecruitmentDetail recruitment={job}>
            <div className={styles.jobCard}>
                <div className={styles.jobContent}>
                    <h4 className={styles.jobName}>{job.recruitment_name || job.title}</h4>
                    <p className={styles.jobDept}>{job.department_name || job.dept}</p>
                    <ul className={styles.jobMeta}>
                        <li>
                            <img src="/bw_image/location.png" alt="Địa điểm" />
                            <span>{job.business_name || job.location_name || 'Địa điểm làm việc'}</span>
                        </li>
                        <li>
                            <img src="/bw_image/working-time-1.png" alt="Thời gian" />
                            <span>
                                {job.employment_type_name || getEmploymentTypeName(job.employment_type, locale)}
                            </span>
                        </li>
                        <li>
                            <img src="/bw_image/calendar.png" alt="Ngày" />
                            <span>{formatDate(job.posted_date) || job.date}</span>
                        </li>
                    </ul>
                </div>
                <button className={styles.jobDetailBtn}>
                    {getLocaleContent(locale, 'page.recruitment.view_details')}
                </button>
            </div>
        </LinkRecruitmentDetail>
    );
}
